var _a;
import * as React from 'react';
import { createSvgIcon, IconDirectionality } from '..';
export var SortableArrows = createSvgIcon((_a = {}, _a[IconDirectionality.LeftToRight] = React.createElement("path", { fill: "currentColor", d: "M8 13L4 9h8zM8 3l4 4H4z" }), _a), 'small');
//# sourceMappingURL=SortableArrows.js.map